module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('section', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }), _vm._v(" "), (_vm.loaded === 'true') ? _c('div', {
    staticClass: "col-xs-12 npd block"
  }, [_c('article', {
    staticClass: "col-sm-12 col-md-9 desarrollo"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.post.title.rendered)
    }
  }), _vm._v(" "), (_vm.post.fechaconformato !== undefined) ? _c('p', [_vm._v(_vm._s(_vm.post.fechaconformato))]) : _vm._e(), _vm._v(" "), (_vm.post.featured_image_src['full'][0]) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.post.featured_image_src['full'][0],
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.post.content.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "compartiren"
  }, [_c('li', [_c('b', [_vm._v("Compartir en")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.post.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.post.link + '&text=' + _vm.post.title.rendered,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "itemwa"
  }, [_c('a', {
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.post.link
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])])])]), _vm._v(" "), _c('aside', {
    staticClass: "hidden-xs hidden-sm col-md-3 sidebar"
  }, [_c('h3', [_vm._v("REFLEXIONES")]), _vm._v(" "), _c('router-link', {
    staticClass: "todo",
    attrs: {
      "to": {
        name: 'cat',
        params: {
          name: 'podcast'
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVer todo >\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.loaded_audio == 'true') ? _c('div', {
    staticClass: "col-xs-12 npd reflexiones__item"
  }, [(_vm.audio.better_featured_image != null) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.audio.better_featured_image.media_details.sizes['536x412'].source_url,
      "alt": ""
    }
  })]) : _c('figure', [_c('img', {
    attrs: {
      "src": 'http://via.placeholder.com/536x412/008AD2/dddddd?text=' + _vm.audio.title.rendered,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reflexiones__title paused"
  }, [_c('button', {
    staticClass: "reflexiones__player",
    attrs: {
      "audio": _vm.audio.post_meta_fields._enclosure_mp3
    }
  }, [_c('i', {
    staticClass: "icon play-mini"
  })]), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.audio.title.rendered)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("ENCUESTA")]), _vm._v(" "), _vm._l((_vm.encuesta), function(_encuesta) {
    return (_vm.loaded_encuesta == 'true') ? _c('div', {
      staticClass: "col-xs-12 npd encuest__item"
    }, [_c('figure', [(_encuesta.poll.image !== '') ? _c('img', {
      attrs: {
        "src": _encuesta.poll.image,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/encuesta.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _vm._l((_vm.encuesta), function(_encuesta) {
      return _c('div', {
        staticClass: "encuesta__datos"
      }, [_c('p', [_vm._v("Tu opinion es muy importante")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_encuesta.poll.question))]), _vm._v(" "), _c('form', {
        staticClass: "wp-polls-form col-xs-12",
        attrs: {
          "action": "/wp-json/wp/v2/poll/",
          "method": "post"
        }
      }, [_c('input', {
        attrs: {
          "type": "hidden",
          "name": "action",
          "value": "polls"
        }
      }), _vm._v(" "), _c('input', {
        attrs: {
          "type": "hidden",
          "name": "view",
          "value": "process"
        }
      }), _vm._v(" "), _c('input', {
        attrs: {
          "type": "hidden",
          "name": "poll_id"
        },
        domProps: {
          "value": _encuesta.poll.id
        }
      }), _vm._v(" "), _vm._l((_encuesta.poll.answers), function(rta) {
        return _c('div', {
          staticClass: "col-xs-12 input-item"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": 'poll_' + _encuesta.poll.id,
            "id": 'rta_' + rta.polla_qid + '_' + rta.polla_aid
          },
          domProps: {
            "value": rta.polla_aid
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": 'rta_' + rta.polla_qid + '_' + rta.polla_aid
          },
          on: {
            "click": function($event) {
              _vm.getEncuesta()
            }
          }
        }, [_vm._v(_vm._s(rta.polla_answers))])])
      })], 2)])
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('h3', [_vm._v("NOVEDADES")]), _vm._v(" "), (_vm.loaded_randpost == 'true') ? _c('div', {
    staticClass: "col-xs-12 npd novedades"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'post',
        params: {
          name: _vm.randpost.slug
        }
      }
    }
  }, [(_vm.randpost.better_featured_image != null) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.randpost.better_featured_image.media_details.sizes['536x412'].source_url,
      "alt": ""
    }
  })]) : _c('figure', [_c('img', {
    attrs: {
      "src": 'http://via.placeholder.com/536x412/008AD2/dddddd?text=' + _vm.randpost.title.rendered,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.randpost.title.rendered)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.randpost.excerpt.rendered)
    }
  })])], 1) : _vm._e()], 2)]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d62362"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/post.vue
// module id = 141
// module chunks = 0